import { exportFileTypes } from '../../../../../models/exportFileTypes';

export enum OrderByEnum {
  CREATED_AT = 'created_at',
  BALANCE = 'balance',
}

export interface FinancialAccountReportFormModel {
  is_open: boolean;
  from?: string;
  to?: string;
  order_by: OrderByEnum;
  with_balance: boolean;
  file_type: exportFileTypes;
}
